import React, { Component } from "react";
import {  Card, Row, Col } from "react-bootstrap";
import { JsonViewer } from '@textea/json-viewer';
import _ from "lodash";

function toFixed(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  return num.toString().match(re)[0];
}

let omitByDeep = (obj, shouldOmit, convertBool, convertFloat) => {
  obj = _.clone(obj);
  _.forEach(obj, (value, key) => {
    if (shouldOmit(value, key)) {
      delete obj[key];
    }
    if (convertBool) {
      if (_.isBoolean(value)) {
        obj[key] = value ? "YES" : "NO";
      }
    }
    if (convertFloat) {
      if (Number.isFinite(value)) {
        if (!Number.isInteger(value)) {
          // must be a float?
          obj[key] = toFixed(value, 2);
        }
      }
    }
    if (_.isPlainObject(value)) {
      obj[key] = omitByDeep(value, shouldOmit, convertBool, convertFloat);
    }
  });
  return obj;
};

export default class ObservationDetailPanel extends Component 
{



  render() {
    const displayGridRow = this.props.currentObservation
      ? omitByDeep(
          this.props.currentObservation,
          (v) => v === null || v === undefined || v === "" || v === 0,
          true,
          true
        ) // immutable. Will NOT change original rowData
      : {"data": {}, "score" : {}, "identifiers": {}};
    if (this.props.currentObservation) {
      console.log(this.props.currentObservation);
      // users do not want to see OUI. I'm doing all of this JUST so I can change the label! Stupid.
      displayGridRow.data.underInspection = displayGridRow.data.oui; // again, will NOT change the original object
      delete displayGridRow.data.oui;
      delete displayGridRow.data.readOnly;
    }


    return (
      <Card>
        <Card.Header align="center">Observation Detail</Card.Header>
        <Card.Body>
          <div style={{ width: "100%", height: "100%" }}>
            <Row>
              <Col><JsonViewer 
                displayDataTypes={false}
                editable={false}
                displaySize={false}
                value={displayGridRow.data}
              />
              </Col>
              <Col>
                <JsonViewer 
                  displayDataTypes={false}
                  editable={false}
                  displaySize={false}
                  value={displayGridRow.score}
                />      
              </Col>
              <Col>
              <JsonViewer 
                displayDataTypes={false}
                editable={false}
                displaySize={false}
                value={displayGridRow.identifiers}
              />   
              <JsonViewer 
                displayDataTypes={false}
                editable={false}
                displaySize={false}
                value={displayGridRow.WorkflowStep}
              />  
              </Col>
            </Row>
          </div>
        </Card.Body>
      </Card>
    );
  }
}
